import { generateClasses } from 'conversional-components';
var generateStyles = function () { return ({
    closeButton: {
        position: 'absolute',
        top: 2,
        right: 2,
        background: '#f00',
        zIndex: 1000,
        fontSize: '16px !important',
        color: '#fff',
        borderRadius: '100%',
        cursor: 'pointer',
        transition: '200ms !important',
        ':hover': {
            transform: 'scale(1.1)',
        },
    },
}); };
export var getStyles = generateClasses(generateStyles);
